import { useQuery } from "@tanstack/react-query";
import { fetchDepthBuckets, type DepthParams } from "../api/client.ts";
import type { DepthBucketRow } from "../api/types.ts";

const POLL_MS = 15_000;

// Pulls a window of depth buckets at a chosen cadence for the time-series chart
// and ladder. Mirrors useSpreadBuckets: window + cadence in the query key, calm
// poll. A high limit so a full 1d @ 5m window (288) isn't truncated.
export function useDepthBucketsSeries(p: DepthParams) {
  const query = useQuery({
    queryKey: [
      "depth-series",
      p.clientId,
      p.venue,
      p.pair,
      p.lookbackMinutes,
      p.bucketSeconds,
    ],
    queryFn: async (): Promise<{ rows: DepthBucketRow[]; count: number }> => {
      const r = await fetchDepthBuckets({ ...p, limit: p.limit ?? 1000 });
      return { rows: r.buckets, count: r.count };
    },
    refetchInterval: POLL_MS,
    staleTime: POLL_MS,
  });
  return {
    ...query,
    rows: query.data?.rows ?? [],
    count: query.data?.count ?? 0,
  };
}
